import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import TrustIndicators from "./components/TrustIndicators";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import FeaturedArticle from "./components/FeaturedArticle";
import ArticleCards from "./components/ArticleCards";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AcBuySpreadsheet",
    "url": "https://acbuyspreadsheets.buzz/",
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
    "description": "The most updated AcBuy spreadsheet with trusted sellers, fashion finds, buying guides, and safety tips.",
    "foundingDate": "2025",
    "areaServed": "Worldwide",
    "sameAs": [
      "https://www.instagram.com/",
      "https://www.youtube.com/",
      "https://x.com/"
    ]
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustIndicators />
        <CategoryGrid />
        <AboutSection />
        <FeaturedArticle />
        <ArticleCards />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
    </>
  );
}